import get from "lodash/get";
import isInteger from "lodash/isInteger";
import omit from "lodash/omit";
import { EMAIL_REGEX, URL_REGEX } from "./constants";
import { VALIDATORS } from "../form/validators";

export const ValidateHelper = {
  isEmail: (value) => {
    const res = value.toString().match(EMAIL_REGEX);
    return res !== null;
  },
  isUrl: (value) => {
    const res = value.toString().match(URL_REGEX);
    return res !== null;
  },
  isNumber: (value) => {
    const res = value.toString().match(/\D/);
    return res === null;
  },
  isEmpty: (value) => value?.toString().trim() === "",
  isLength: (value, len) => !!(value && value.toString().length === len),
  maxStrLengthN(val = "", length) {
    return isInteger(length) && typeof val === "string" && val.length > length;
  },
  minStrLengthN(val = "", length) {
    return isInteger(length) && typeof val === "string" && val.length < length;
  },
};

export const { isEmail, isUrl, isEmpty, isNumber, maxStrLengthN, minStrLengthN } = ValidateHelper;

export const Validator = (fieldObj) => {
  const { value = "", validates = {} } = fieldObj;
  const errors = [];
  let key;
  for (key in validates) {
    switch (key) {
      case "presence":
        validates[key] && isEmpty(value) ? errors.push("Required") : "";
        break;

      case "email":
        !isEmail(value) ? errors.push("Invalid Email") : "";
        break;
      case "length": {
        const lengthObj = get(validates, key);
        maxStrLengthN(value, lengthObj.max) ? errors.push(`Max ${lengthObj.max} characters`) : "";
        minStrLengthN(value, lengthObj.min) ? errors.push(`Min ${lengthObj.min} characters`) : "";
        break;
      }
    }
  }
  return errors;
};

export const multiValidator = (fieldObj, formValues) => {
  const { value = "", validates = {} } = fieldObj;
  const errors = [];

  const tryValidations = !validates.runValidations || validates.runValidations(formValues);
  if (tryValidations) {
    Object.keys(omit(validates, "runValidations")).forEach((key) => {
      const { valid, error } = VALIDATORS[key]?.({ validates, key, value, formValues });
      if (!valid) {
        errors.push(error);
      }
    });
  }
  return errors;
};
